module.exports = __webpack_public_path__ + "img/image.ef447795.svg";